import { useReducer, createContext, useContext, ReactNode, JSX } from 'react';
import {
    ContactTypeEnum,
    UploadWizardAction,
    UploadWizardContextType,
    UploadWizardState,
} from '../../../../types/uploadWizard';

const UploadWizardContext = createContext<UploadWizardContextType | undefined>(undefined);

const uploadWizardReducer = (
    state: UploadWizardState,
    action: UploadWizardAction,
): UploadWizardState => {
    switch (action.type) {
        case 'contact-type': {
            return { ...state, contactType: action.payload };
        }
        case 'used-template': {
            return { ...state, usedTemplate: action.payload.usedTemplate };
        }
        case 'picked-group': {
            return { ...state, pickedGroup: action.payload };
        }
        case 'picked-groups': {
            return { ...state, pickedGroups: action.payload };
        }
        case 'csv': {
            return { ...state, csvFile: action.payload.csvFile };
        }
        case 'need-to-crawl': {
            return { ...state, needToCrawl: action.payload };
        }
        default: {
            return state;
        }
    }
};

type UploadWizardProviderProps = {
    children: ReactNode;
};

const UploadWizardProvider = ({ children }: UploadWizardProviderProps): JSX.Element => {
    const [state, dispatch] = useReducer(uploadWizardReducer, {
        contactType: ContactTypeEnum.PROSPECTS,
        usedTemplate: false,
        pickedGroup: undefined,
        pickedGroups: [],
        csvFile: { name: null, data: [] },
        needToCrawl: false,
    });

    const value = { state, dispatch };

    return <UploadWizardContext.Provider value={value}>{children}</UploadWizardContext.Provider>;
};

const useUploadWizard = (): UploadWizardContextType => {
    const context = useContext(UploadWizardContext);
    if (context === undefined) {
        throw new Error('useUploadWizard must be used within an UploadWizardProvider');
    }
    return context;
};

export { UploadWizardProvider, useUploadWizard };
